import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import * as userActions from '../../actions/user';
import { connect } from 'react-redux';
import Translate from '../layout/Translate';
import Login from '../popups/Login';

class DeparturesHeader extends Component {



	toggleLangSelect() {
		if (!this.props.user.langSelectOpen) {
			this.props.userActions.toggleLangSelect();
		}
	}
	selectCurrency(currency) {
		this.props.userActions.selectCurrency(currency);
		this.props.userActions.toggleLangSelect()
	}

  render() {

  	const { user } = this.props;

	  let path = (this.nextProps && this.nextProps.path)?this.nextProps.path.location.pathname:'',
		  hosts = {
			  ru: 'http://www.baikalnature.ru',
			  en: 'http://www.baikalnature.com',
			  fr: 'http://www.baikalnature.fr'
		  };

    return (
			<div className="header header_departures">
				<ul className="header__menu main-menu main-menu_departures">

					<li className="main-menu__item main-menu__item_black">
						<div className={"lang-select " + (this.props.user.langSelectOpen?'lang-select_active':'')}>
							<div className="lang-select__values" onClick={this.toggleLangSelect.bind(this)}>
								<span className="lang-select__value">{this.props.user.lang}</span>
								<span className={"lang-select__value lang-select__value_" + this.props.user.currency.id}>{(this.props.user.currency.id=='RUR')?'i':this.props.user.currency.sign}</span>
								<div className={"lang-select__arrow " + (this.props.user.langSelectOpen?'lang-select__arrow_active':'lang-select__arrow_black')}></div>
							</div>
							<div className={"lang-select__lists " + (this.props.user.langSelectOpen?'lang-select__lists_active':'')}>
								<ul className="lang-select__list">
									<li className={"lang-select__item " + (this.props.user.lang=='ru'?'lang-select__item_active':'')}><a href={hosts['ru'] + path}>RU</a></li>
									<li className={"lang-select__item " + (this.props.user.lang=='en'?'lang-select__item_active':'')}><a href={hosts['en'] + path}>EN</a></li>
									<li className={"lang-select__item " + (this.props.user.lang=='fr'?'lang-select__item_active':'')}><a href={hosts['fr'] + path}>FR</a></li>
								</ul>
								<ul className="lang-select__list">
									{this.props.user.currencyList.map((currency, i)=>
										<li className={"lang-select__item lang-select__item_" + currency.id + (this.props.user.currency.id==currency.id?' lang-select__item_active':'')}  onClick={this.selectCurrency.bind(this, currency)}>{(currency.id=='RUR')?'i':currency.sign}</li>
									)}
								</ul>
							</div>
						</div>
					</li>

				</ul>
			</div>
    );
  }
}



function mapStateToProps(state) {
	return {
		user : state.user
	};
}


function mapDispatchToProps(dispatch) {
	return {
		userActions: bindActionCreators(userActions, dispatch)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DeparturesHeader);



// WEBPACK FOOTER //
// ./src/common/components/layout/DeparturesHeader.js